import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import {
  actionIcons,
  keyStrokes,
  searchDataParam,
} from '../../utility/constants';
import { isActiveElementInsideCdkOverlay } from './paginator-keyboard-guards';

@Directive({
  selector: '[appEnterSubmit]',
})
export class AppEnterSubmitDirective {
  @Input() appEnterSubmit!: string;

  constructor(private readonly el: ElementRef) {}

  @HostListener('document:keydown', ['$event'])
  onEnterKeyPress(event: KeyboardEvent) {
    if (event.key === keyStrokes.enter) {
      // SPEC-BUX-001 FR-BUX-017/024: Enter in a textarea is a line break, not a save.
      if (
        isActiveElementInsideCdkOverlay() ||
        event.target instanceof HTMLTextAreaElement
      ) {
        return;
      }
      let preventDefault = false;
      let iconClass: string | null = null;
      switch (this.appEnterSubmit) {
        case searchDataParam.summary:
          iconClass = actionIcons.filter;
          break;
        case searchDataParam.information:
          iconClass = actionIcons.save;
          break;
        case searchDataParam.basicSearch:
          iconClass = searchDataParam.basicSearch;
          break;
        default:
          preventDefault = true;
          break;
      }
      this.triggerClick(event, iconClass, preventDefault);
    }
  }

  private triggerClick(
    event: KeyboardEvent,
    iconClass: string | null,
    preventDefault: boolean
  ) {
    if (iconClass && !preventDefault) {
      const iconElement = this.el.nativeElement.querySelector(
        `.${iconClass}`
      ) as HTMLElement;
      if (iconElement) {
        const iconStyle = window.getComputedStyle(iconElement);
        if (iconStyle.getPropertyValue('pointer-events') === 'none') {
          event.preventDefault();
          return;
        }
        iconElement.click();
      }
      event.preventDefault();
    }
  }
}
